import { ComponentType } from 'react';

import { ApiResponse } from '@/types';

import { AlertTriangleIcon, CheckIcon, FaceNeutralIcon } from '@/assets/icons';
import { IDropdownSearchResponse } from '@/components/common';

import { CheckInStatus, ProfileType } from '@/features/check-in-logs/enums';
import { IIpadSerialNumberSearchResponse } from '@/features/ipad-configs/interfaces';

import { ITableCellStatus } from '@/components/common/Table/Table.interfaces';

export const getCheckInStatusLabel = (status: CheckInStatus): string => {
  switch (status) {
    case CheckInStatus.Success:
      return 'Success';
    case CheckInStatus.Failed:
      return 'Failed';
    case CheckInStatus.SpoofingSuspected:
      return 'Spoofing Suspected';
  }
};

export const getCheckInStatusVariant = (
  status: CheckInStatus,
): ITableCellStatus['statusVariant'] => {
  switch (status) {
    case CheckInStatus.Failed:
      return 'error';
    case CheckInStatus.Success:
      return 'completed';
    case CheckInStatus.SpoofingSuspected:
      return 'pending';
    default:
      return 'default';
  }
};

export const getCheckInStatusIcon = (
  status: CheckInStatus,
): ComponentType<{ className?: string }> => {
  switch (status) {
    case CheckInStatus.Success:
      return CheckIcon;
    case CheckInStatus.Failed:
      return AlertTriangleIcon;
    case CheckInStatus.SpoofingSuspected:
      return FaceNeutralIcon;
  }
};

export const getProfileTypeLabel = (type: ProfileType): string => {
  switch (type) {
    case ProfileType.Employee:
      return 'Employee';
    case ProfileType.Guest:
      return 'Guest';
  }
};

export const mapSerialNumberResponseToDropdownSearchResponse = (
  response: ApiResponse<IIpadSerialNumberSearchResponse>,
): IDropdownSearchResponse => {
  if (!response.data || !response.data.data) {
    return { data: [], cursor: undefined };
  }

  return {
    data: response.data.data.map((item) => ({
      value: item.serialNumber,
      label: item.name ?? 'N/A',
      cursor: item.id,
    })),
    cursor: response.data.metadata?.cursor,
  };
};
